import React from 'react';
import {  Outlet , useParams } from "@bcm-dev/bcms-vite";
import "./styles.css";
import MainContentContainer, { MainContentHeader } from 'components/shared/containers/MainContentContainer';
import TabsContainer, { TabItem } from 'components/shared/containers/TabsContainer';

/**
 * @function ControlsAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ControlsAlertsPage
 * @example
 * <ControlsAlertsPage />
 */
export default function ControlsAlertsPage(props) {
  const cardID = useParams().cardID ?? "0";

  const controlsActive = [ "/home/controlsalerts", "/home/controlsalerts/controls",`/home/controlsalerts/controls/${ cardID }` ];
  const alertsActive = [ `/home/controlsalerts/alerts`,`/home/controlsalerts/alerts/${ cardID }` ];

  return (
    <MainContentContainer header={<MainContentHeader text="Controls &amp; Alerts" />} className="controls-alerts-page">
      <p className="description-text">Receive notifications and set controls on where, when, and how your card is used.</p>
      <TabsContainer>
        <TabItem activeClass="active-tab active" activeRoute={ controlsActive } route={`/home/controlsalerts/controls/${ cardID }`} text="Controls"dataPoint="controls_tab" />
        <TabItem activeClass="active-tab active" activeRoute={ alertsActive } route={`/home/controlsalerts/alerts/${ cardID }`} text="Alerts" dataPoint="alerts_tab"/>
      </TabsContainer>
      <div className="tab-content-container">
        <Outlet />
      </div>
    </MainContentContainer>
  )
}
